"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keys = {
    RESOURCE_ADD: "RESOURCE_ADD",
    RESOURCE_FIND_ALL: "RESOURCE_FIND_ALL",
    RESOURCE_FIND_ONE: "RESOURCE_FIND_ONE",
    RESOURCE_UPDATE_COLUMN: "RESOURCE_UPDATE_COLUMN",
    RESOURCE_UPDATE_COLUMNS: "RESOURCE_UPDATE_COLUMNS",
    RESOURCE_UPDATE_RECORD: "RESOURCE_UPDATE_RECORD",
    RESOURCE_REMOVE: "RESOURCE_REMOVE",
};
exports.default = keys;
//# sourceMappingURL=keys.js.map